import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import ComparisonItem from '@/types/comparison-item';
import TaxAnalysisOverview from '@/views/components/proposals/grid-elements/TaxAnalysisOverview';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import { ProposalDAOInterface } from '../ProposalDAO';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import { TaxAnalysisOverviewValue } from '@/types/tax-analysis';

/**
 * Tax Analysis Overview DAO
 */
export default class TaxAnalysisOverviewDAO extends ComparisonItemBasedProposalDAO implements ProposalDAOInterface {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new TaxAnalysisOverviewDAO(proposal, proposalElement);
  }

  items: ComparisonItem[];

  originalComparisonItem?: ComparisonItem;

  targetComparisonItem?: ComparisonItem;

  constructor(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement) {
    // Filter to only include the original portfolio item before parent constructor runs
    const originalItemId = proposal.taxAnalysis?.originalComparisonItemId;

    // Store references to both items before filtering
    const originalItem = proposal.items.find(item => item._id === proposal.taxAnalysis?.originalComparisonItemId);
    const targetItem = proposal.items.find(item => item._id === proposal.taxAnalysis?.targetComparisonItemId);

    if (originalItemId) {
      const filteredProposal = {
        ...proposal,
        items: proposal.items.filter(item => item._id === originalItemId),
      };
      super(filteredProposal, proposalElement);
    } else {
      super(proposal, proposalElement);
    }

    this.items = proposal.items;
    this.originalComparisonItem = originalItem;
    this.targetComparisonItem = targetItem;
  }

  protected getColorKeys(): string[] {
    return [];
  }

  protected async build(): Promise<void> {
    let itemDAO: ComparisonItemDAO | null = null;

    while ((itemDAO = this.nextItem()) !== null) {
      if (this.proposal.taxAnalysis?.taxSettings) {
        this.addItemField(itemDAO, '', {
          originalComparisonItem: this.originalComparisonItem,
          targetComparisonItem: this.targetComparisonItem,
          taxSettings: this.proposal.taxAnalysis?.taxSettings,
        });
      }
    }
  }

  private addItemField(itemDAO: ComparisonItemDAO, name: string, value: TaxAnalysisOverviewValue): TaxAnalysisOverviewValue {
    const field: ProposalFieldDAO = new ProposalFieldDAO(name, value, ProposalStyleClassNames.ProposalTableContent);

    field.cellType = TaxAnalysisOverview;
    field.decimalPlace = 2;
    this.addFieldDAO(itemDAO, field);
    return value;
  }
}
